import React, { useEffect } from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';
import {Issue} from "~/types";
import useTranslation from "~/app/hooks/useTranslation";
import LinkWrapper from "~/app/common/LinkWrapper";
import {MACHINES_DETAILS_ROUTES} from "~/machines/Details/Router";
import {route} from "~/app/helpers/route";
import { useStoreActions, useStoreState } from '~/store';
import { getContrastYIQ, getLabelsMap } from '~/issues/helpers';
import AccessControl from '~/accessControl';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';

export interface ListItemProps {
    item: Issue
    listClassName?: string
    awaitingSync?: boolean
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({item, listClassName, awaitingSync}) => {

    const {t} = useTranslation("issue");
    const {t: tOffline} = useTranslation("offline");

    const machineId = useStoreState(state => state.machine.data.id);
    const fetchingLabels = useStoreState(state => state.issue.fetchingLabels);
    const fetchLabels = useStoreActions(actions => actions.issue.fetchLabels);
    const labels = useStoreState(state => state.issue.labels);

    useEffect(() => {
        if (labels.length === 0) {
            fetchLabels();
        }
    }, [fetchLabels, labels.length]);

    if (fetchingLabels) {
        return <></>;
    }

    return (
        <LinkWrapper className={`${classes['list-item']} ${listClassName && classes[listClassName]}`}
                     to={route(MACHINES_DETAILS_ROUTES.issueDetails, {id: machineId, issueId: item.id})}>
            <div className={classes['info']}>
                {item.categoryName ? (
                    <>
                        <div className={classes['title']}>{item.categoryName}</div>
                        <div className={classes['description']}>{item.description}</div>
                    </>
                ) : (
                    <div className={classes['title']}>{item.description}</div>
                )}
                <div className={classes['details']}>
                    <span className={`${classes['type']} ${classes[item.type]}`}>{t(`types.${item.type}`)}</span>
                    {item.dueDate && <span className={classes['due-date']}>
                        <Icon name='event_available' size="13" />
                        {t('dueDate', {date: item.dueDate})}
                    </span>}
                    <span>{t('issueDate', {date: item.statusDate})}</span>
                </div>
                <div className={`${classes['details-2']}`}>
                    <span className={classes['status']}>{t(`statuses.${item.status}`)}</span>
                    {awaitingSync && <span className={classes['awaiting-sync']}>{tOffline('awaitingSynchronization')}</span>}
                    <AccessControl requiredPermissions={PERMISSION_GROUPS.viewIssueTag}>
                        {item.labels && labels && item.labels.split(",")
                            .map(label => getLabelsMap(labels).get(parseInt(label)))
                            .filter(issueLabel => issueLabel && issueLabel?.id && issueLabel.id !== 1)
                            .map((issueLabel, index) => (
                                <span
                                    key={index}
                                    className={classes['issue-label']}
                                    style={{
                                        background: issueLabel?.colorName,
                                        color: getContrastYIQ(issueLabel?.colorName),
                                    }}
                                >
                                    {issueLabel?.name}
                                </span>
                            ))}
                    </AccessControl>
                </div>
            </div>
            <div className={classNames(classes['right-icon-wrap'])}>
                <Icon name="keyboard_arrow_right"/>
            </div>
        </LinkWrapper>
    );
};

export default ListItem
